import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Icon } from '@/components/common/Icon';
import { ASSISTANT_TARGET_KEY } from '@/components/assistant/uiActions/assistantTargetKeys';
import { useAssistantTarget } from '@/components/assistant/uiActions/useAssistantTarget';
import { MembersTable } from './MembersTable';
import { InvitationsPanel } from './InvitationsPanel';
import { InviteMemberModal } from './InviteMemberModal';

export function MembersManagementSection() {
  const { t } = useTranslation('team');
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const inviteButtonTargetRef = useAssistantTarget(ASSISTANT_TARGET_KEY.teamInviteButton);

  return (
    <div className="space-y-5">
      <div className="flex justify-end">
        <Button
          ref={inviteButtonTargetRef}
          onClick={function openInviteModal() {
            setIsInviteModalOpen(true);
          }}
        >
          <Icon name="UserPlus" />
          {t('invite.action')}
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <MembersTable />
        <InvitationsPanel />
      </div>

      {isInviteModalOpen === true ? (
        <InviteMemberModal
          onClose={function closeInviteModal() {
            setIsInviteModalOpen(false);
          }}
        />
      ) : null}
    </div>
  );
}
